import { Link } from "react-router-dom";

export default function Tasks() {
  return (
    <div className="container text-center mt-5">
      <div className="row justify-content-center mb-4 mx-1">
        <div
          className="col-sm-12 col-lg-9 py-4 px-5 rounded-4 text-white bg-dark fs-5"
          style={{
            textShadow:
              "0 0 7px #08F, 0 0 10px #08F, 0 0 21px #08F, 0 0 42px #08F",
            boxShadow: "0 0 7px #08F, 0 0 10px #08F, 0 0 14px #08F",
          }}
        >
          <div className="row">
            <div className="col-12 col-md-1">
              <i className="bi bi-filetype-js display-5"></i>
            </div>
            <div className="col-12 col-md-11">
              Якщо ви давно шукали класні задачі з JavaScript, та ще й рідною
              українською мовою, вітаємо - ви їх знайшли! Ми ретельно
              продумували кожну задачу, щоб підготувати вас до майбутніх
              викликів у ролі фронтенд-розробника. Поки задач не так багато,
              проте, за вашої зацікавленості, кількість задач буде стрімко
              зростати. Наразі пропонуємо вирішити задачі з таких розділів:
            </div>
          </div>
        </div>
      </div>

      <div className="row justify-content-center my-4">
        <div className="col-sm-12 col-md-4 col-lg-3 my-4 ">
          <div
            className="py-4 px-4 rounded-4 bg-dark text-center"
            style={{
              boxShadow: "0 0 7px #FF0, 0 0 10px #FF0, 0 0 14px #FF0",
            }}
          >
            <Link
              to="/tasks/Functions"
              className="text-white fs-5"
              style={{
                textDecoration: "none",
                transition: "color 0.3s ease",
                textShadow:
                  "0 0 7px #FF0, 0 0 10px #FF0, 0 0 21px #FF0, 0 0 42px #FF0",
              }}
            >
              <i class="bi bi-list-task pe-2"></i>
              Функції
            </Link>
          </div>
        </div>
        <div className="col-sm-11 col-md-4 col-lg-3 my-4 ">
          <div
            className="py-4 px-4 rounded-4 bg-dark text-center"
            style={{
              boxShadow: "0 0 7px #FF0, 0 0 10px #FF0, 0 0 14px #FF0",
            }}
          >
            <Link
              to="/tasks/dom"
              className="text-white fs-5"
              style={{
                textDecoration: "none",
                transition: "color 0.3s ease",
                textShadow:
                  "0 0 7px #FF0, 0 0 10px #FF0, 0 0 21px #FF0, 0 0 42px #FF0",
              }}
            >
              <i class="bi bi-bezier pe-2"></i>
              DOM
            </Link>
          </div>
        </div>
        <div className="col-sm-12 col-md-4 col-lg-3 my-4 ">
          <div
            className="py-4 px-4 rounded-4 bg-dark text-center"
            style={{
              boxShadow: "0 0 7px #FF0, 0 0 10px #FF0, 0 0 14px #FF0",
            }}
          >
            <Link
              to="/tasks/high-priority"
              className="text-white fs-5"
              style={{
                textDecoration: "none",
                transition: "color 0.3s ease",
                textShadow:
                  "0 0 7px #FF0, 0 0 10px #FF0, 0 0 21px #FF0, 0 0 42px #FF0",
              }}
            >
              <i className="bi bi-star-fill pe-2"></i>
              Складний рівень
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
